export function canEdit(user) {
  return !!user && (user.role === "editor" || user.role === "admin");
}
export function canAdmin(user) {
  return !!user && user.role === "admin";
}
